import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=05175c64"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports